import { render, staticRenderFns } from "./templateTwo.vue?vue&type=template&id=05e560ff&scoped=true"
import script from "./templateTwo.vue?vue&type=script&lang=js"
export * from "./templateTwo.vue?vue&type=script&lang=js"
import style0 from "./templateTwo.vue?vue&type=style&index=0&id=05e560ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e560ff",
  null
  
)

export default component.exports